<template>
  <div class="custom-form custom-form--presonal-info">
    <div class="custom-form__header">
      <slot name="content-introduction" />
    </div>
    <form @submit.prevent="submit"
          novalidate autocomplete="off">

      <field-radio class="gender-block radio-btn-mob"
                   v-model="form.gender"
                   :field="fieldGender" />

      <div class="columns">
        <div class="column">
          <div class="fieldset">
            <field-input v-model="form.firstName"
                         :v="$v.form.firstName"
                         :field="fieldFirstName" />
          </div>
        </div>

        <div class="column">
          <div class="fieldset">
            <field-input v-model="form.lastName"
                         :v="$v.form.lastName"
                         :field="fieldLastName" />
          </div>
        </div>

        <div class="column full-width group-field">
          <date-of-birth @birth="setBirthData" :field-birth="fieldBirth" :start-validate="validateDate" :legend-dob="legendDob" @birthIsValid="setBirthValidation" />
        </div>
      </div>

      <!-- New fielsd -->
      <div v-if="mountFields && !!fieldsList">
        <div class="section"
             :class="[ section === 2 && 'section--no-cols']"
             v-for="(itemCollection, section) in fieldsList"
             :key="section + 's'">
          <h2 class="is-3 full-width" v-if="!!itemCollection.title" v-html="itemCollection.title" />
          <div class="columns"  :class="[ismobileprefix ? 'mobile-prefix-class' :  '']">
            <div class="column"
                 :class="[ item.id === 'request' && 'full-width', !!item.group ? 'full-width group-field' : '', item.type && item.id !== 'kids' && `${item.type}`]"
                 v-for="item in itemCollection.fields"
                 :key="`${fieldsKey}-${!!item.id ? item.id : item.group.id}`">
              <template v-if="!item.group">
            <div class="mobile-field"  v-if="item.mobileprefix && item.mobileprefix.id === 'mobile-prefix'">
                <form-item @fieldval="(data) => setFormVal(data)"
                           class="mobile-prefix"
                           v-if="item.mobileprefix && item.mobileprefix.id === 'mobile-prefix'"
                           :v="$v.form['mobile-prefix']"
                           :data="fieldsData['mobile-prefix']"
                           :input-value="form['mobile-prefix']"
                           type="text"
                           html-tag="h3"
                           :update-field="updateSelectFields"
                           :disable-state="disableState" />
                 <form-item @fieldval="(data) => setFormVal(data)"
                           :class="[item.id === 'phone' &&  ismobileprefix  ? 'phone' : '']"
                           v-if="(item.required || item.regExp)"
                           :data="item.id !== 'state' ? item : fieldsData.state"
                           :input-value="form[item.id]"
                           :type="item.type"
                           :html-tag="section === 2 ? 'h3' : undefined"
                           :update-field="updateSelectFields"
                           :disable-state="(item.id === 'state') ? disableState : (item.id === 'kidsCount') ? kidsSelectDisabled : false" />
              </div>
                 

                <form-item v-else
                           @fieldval="(data) => setFormVal(data)"
                           :data="item.id !== 'state' ? item : fieldsData.state"
                           :input-value="form[item.id]"
                           :type="item.type"
                           :html-tag="section === 2 ? 'h3' : undefined"
                           :update-field="updateSelectFields"
                           :disable-state="item.id === 'state' ? disableState : false" />
              </template>

              <form-group v-else
                          :data="item.group"
                          :values="form[item.group.id]"
                          @groupchecked="(data) => setGroupValidation(data)"
                          @groupvalue="(data) => setGroupVal(data)">
                <h3 class="form-group__heading is-4" :id="`legend-${item.group.id}`">{{ item.group.label }}</h3>
              </form-group>

            </div>
          </div>

        </div>
      </div>
      <!-- /New fielsd -->

      <div class="custom-form__checkbox-group"
           v-for="(item, index) in fieldCheckboxes"
           :key="index">
        <field-checkbox v-if="item.required"
                        :value="form.gdpr[`checkbox-${item.gdprId}`]"
                        v-model="form.gdpr[`checkbox-${item.gdprId}`]"

                        :field="item" />
        <field-checkbox v-else
                        :value="form.gdpr[`checkbox-${item.gdprId}`]"
                        v-model="form.gdpr[`checkbox-${item.gdprId}`]"
                        :field="item" />
      </div>

      <captcha ref="captcha"
               v-if="fieldCaptcha.isVisible"
               :captcha-id="fieldCaptcha.id"
               :captcha-sitekey="fieldCaptcha.siteKey"
               :explicitly-render="true"
               @captchaError="(value) => this.getCaptchaError(value)">
        <p class="field-help"
           v-if="hasErrorCapcha"
           :id="fieldCaptcha.idError">
          {{ fieldCaptcha.error }}
        </p>
      </captcha>

      <div class="custom-form__actions">
        <div class="btn-group">
          <div>
            <a :href="template.ctaLinks.cancel.url" title="Link"
              :class="ctaClass"
              v-tag:useractionevent="{
                label: 'cancel',
                category: 'registration',
                action: 'select',
                event_name: 'body_button_click',
                module_name: 'custom form personal info',
                cta_name: 'cancel',
                link_url: `${this.requestUrl}` + template.ctaLinks.cancel.url
              }">
              <span class="btn__wrapper btn__wrapper--cross">{{ template.ctaLinks.cancel.text }}</span>
            </a>
          </div>
          <div>
            <button type="submit"
              :class="ctaClass"
              v-tag:useractionevent="{
                label: 'save',
                category: 'registration',
                action: 'select',
                event_name: 'body_button_click',
                module_name: 'custom form personal info',
                cta_name: 'save',
                link_url: `${this.requestUrl}` + template.ctaLinks.save.url
              }">
              <span class="btn__wrapper">{{ template.ctaLinks.save.text }}</span>
            </button>
          </div>
        </div>
        <div role="alert">
          <p v-if="serverResponse !== null"
             class="custom-form__response"
             :class="{ 'error': !serverResponse }">{{ serverResponse ? template.succeed : template.failure.default }}</p>
          <p v-if="serverError !== null"
             class="custom-form__response error">{{ template.error }}</p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { minLength, required, sameAs, helpers } from 'vuelidate/lib/validators';
  import { tag } from '@Foundation/analyticsHandler';
  import { validationMixin } from 'vuelidate';
  import { postData } from '@Foundation/services';
  import FieldCheckbox from '@Feature/CustomForms/fields/FieldCheckbox/code/Scripts/components/field-checkbox.vue';
  import FieldInput from '@Feature/CustomForms/fields/FieldInput/code/Scripts/components/field-input.vue';
  import FieldRadio from '@Feature/CustomForms/fields/FieldRadio/code/Scripts/components/field-radio.vue';
  import FieldSelect from '@Feature/CustomForms/fields/FieldSelect/code/Scripts/components/field-select.vue';
  import FieldTextarea from '@Feature/CustomForms/fields/FieldTextarea/code/Scripts/components/field-textarea.vue';
  import FormItem from '@Feature/CustomForms/FormItem/code/Scripts/components/form-item';
  import FormGroup from '@Feature/CustomForms/FormGroup/code/Scripts/components/form-group';
  import dateOfBirth from '@Feature/CustomForms/dateOfBirth/code/Scripts/components/date-of-birth.vue';
  import Captcha from '@Feature/Captcha/code/Scripts/components/captcha.vue';

  /**
   * Custom validators vor Vuelidate
   */
  // const phoneFormat = helpers.regex('phoneFormat', /(?=.*[0-9])/);
  const alphaExtended = helpers.regex('alphaExtended', /^[a-zA-Zа-яА-ЯёЁіІàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]{3,50}$/u);

  export default {
    name: 'custom-form-personal-info',

    components: { FieldCheckbox, FieldInput, FieldRadio, FieldSelect, FieldTextarea, dateOfBirth, Captcha, FormItem, FormGroup },

    directives: { tag },

    mixins: [validationMixin],

    props: {
      fieldGender: { type: Object, required: true, default: undefined },
      fieldFirstName: { type: Object, required: true, default: undefined },
      fieldLastName: { type: Object, required: true, default: undefined },
      fieldCheckboxes: { type: Array, required: true, default: undefined },
      fieldBirth: { type: Object, required: true, default: undefined },
      fieldCaptcha: { type: Object, required: false, default: undefined },
      template: { type: Object, required: true, default: undefined },
      apiUrl: { type: String, required: true, default: undefined },
      longVersionData: { type: [Array, String], required: false, default: undefined },
      ctaClass: { type: String, default: 'btn btn--black' },
      legendDob: { type: Number, required: false },
    },

    data() {
      return {
        form: {
          gender: '',
          firstName: '',
          lastName: '',
          gdpr: {},
          birth: {
            day: '',
            month: '',
            year: ''
          }
        },
        fieldsData: {},
        fieldsKey: Date.now(),
        checkboxFieldIDs: [],
        mountFields: false,
        updateSelectFields: false,
        disableState: false,
        serverResponse: null,
        serverError: null,
        hasErrorCapcha: false,
        isBirthValid: true,
        validateDate: false,
        groupValidation: new Map(),
        isGroupsValid: null,
        validationSettings: {
          form: {
            firstName: {
              required,
              alphaExtended,
              minLength: minLength(3),
            },
            lastName: {
              required,
              alphaExtended,
              minLength: minLength(3),
            },
            gdpr: {}
          }
        },
        regExp: {},
       ismobileprefix : false,
       requestUrl: null
      };
    },

    /**
     * Vuelidate config
     * @see {@link https://github.com/monterail/vuelidate|GitHub}
     */
    validations() {
      return {
        form: this.vulidateSettings
      };
    },

    computed: {
      fieldsList: {
        get() {
          return this.longVersionData.map((itemsCollection) => {
            return {
              title: itemsCollection.section.title,
              fields: itemsCollection.section.items.map((item) => {
                  if(item.id === "mobile-prefix") {
                  this.ismobileprefix = true;
                  }
                /* istanbul ignore else */
                if (!!item.type || !!item.group.options.length) {
                  return item;
                }
              })
            };
          });
        },
        set(value) {
          const section = this.fieldsData[value.id].index.section;
          const item = this.fieldsData[value.id].index.indexInSection;

          this.fieldsList[section].fields[item].info = value.info;
        }
      },

      isExtendedForm() {
        return !!this.longVersionData;
      },

      vulidateSettings: {
        get() {
          // GDPR checkboxes
          for (let index = 0; index < this.fieldCheckboxes.length; index++) {
            if (this.fieldCheckboxes[index].required) {
              this.$set(this.validationSettings.form.gdpr, `checkbox-${this.fieldCheckboxes[index].gdprId}`, {
                required,
                sameAs: sameAs(() => true)
              });
            }
          }

          /* istanbul ignore else */
          if (this.isExtendedForm) {
            // Dynamic validation
            this.longVersionData.forEach((block) => {
              block.section.items.forEach((blockItem) => {
                /* istanbul ignore else */
                if (blockItem.regExp) {
                  this.setRegexp({ field: blockItem.id, regexp: blockItem.regExp });
                }
                /* istanbul ignore else */
                if (blockItem.required || blockItem.regExp) {
                  /* istanbul ignore next */
                  if (blockItem.type === 'checkbox') {
                    this.$set(this.validationSettings.form, blockItem.id, {
                      required,
                      /* istanbul ignore next */
                      sameAs: sameAs(() => true)
                    });
                  } else {
                    if (blockItem.regExp && blockItem.required) {
                      this.$set(this.validationSettings.form, blockItem.id, {
                        required,
                        regexpval: helpers.regex('regexpval', new RegExp(this.regExp[blockItem.id])),
                      });
                    } else if (blockItem.required) {
                      this.$set(this.validationSettings.form, blockItem.id, {
                        required,
                      });
                    } else {
                      this.$set(this.validationSettings.form, blockItem.id, {
                        regexpval: helpers.regex('regexpval', new RegExp(this.regExp[blockItem.id])),
                      });
                    }
                  }
                } else if (blockItem.group) {
                  return false;
                }

              });
            });
          }

          return this.validationSettings.form;
        },
        set(newValue) {
          this.$set(this.validationSettings.form, newValue, {
            regexpval: helpers.regex('regexpval', new RegExp(this.regExp[newValue])),
          });
        }
      },

      country() {
        return this.form.country;
      },
      state: {
        get() {
          return this.fieldsData.state;
        },
        set(value) {
          this.form['state'] = value;
          this.fieldsData['state'].value = value;
        }
      },
      mobileprefix: {
        get() {
          return this.fieldsData['mobile-prefix'];
        },
        set(value) {
          this.form['mobile-prefix'] = value;
          this.fieldsData['mobile-prefix'].value = value;
        }
      }
    },

    watch: {
      country(value) {
        this.getCountryStates(value);
      }
    },

    created() {
      this.setCheckboxesToVueData();
      window.onCaptchaAPIReady = this.onCaptchaAPIReady;
    },

    mounted() {
      this.requestUrl = window.location.origin;
      if(this.ismobileprefix){
        let index
        let mainindex
        let mobileprefix 
        this.fieldsList.forEach((data,e)=>{
          data.fields.forEach((item,i)=>{
            if(item.id == 'mobile-prefix'){
              index = i;
              mainindex = e;
            };
          });
        });
        if(index) {
          mobileprefix = this.fieldsList[mainindex].fields.splice(index,1);
          this.fieldsList.forEach((data,e)=>{
            data.fields.forEach((item,i)=>{
              if(item.id == 'phone'){
                item.mobileprefix = mobileprefix[0];
              }
            });
          });
        }
       }
      /* istanbul ignore else */
      if (this.isExtendedForm) {
        this.mapperFields();
      }

      this.isGroupsValid = this.checkGroupsValid();
      setTimeout(() => {
        this.setPredefinedValues();
      }, 500);
    },

    /* eslint-disable no-undef */
    methods: {
      /* cusom fields creation */
      setRegexp(val) {
        this.regExp[val.field] = val.regexp;
      },
      checkGroupsValid() {
        const result = [];
        for (const amount of this.groupValidation.values()) {
          /* istanbul ignore next */
          amount && result.push(amount);
        }
        return result.length > 0 || this.groupValidation.size === 0;
      },
      setGroupValidation(payload) {
        const { group, checked } = payload;
        this.groupValidation.set(group, checked);
        this.isGroupsValid = this.checkGroupsValid();
      },
      setFormVal(payload) {
        const { name, value } = payload;
        this.form[name] = value;
      },
      setGroupVal(payload) {
        const { group, name, value } = payload;
        this.form[group][name] = value;
      },

      /**
       * init data valuse for long form registartion
       */
      mapperFields() {
        this.longVersionData.forEach((block, blockIndex) => {
          block.section.items.forEach((blockItem, blockItemIndex) => {
            let value;
            if (!blockItem.group) {
              typeof blockItem.value === 'boolean' || typeof blockItem.value === 'string' ? value = blockItem.value : value = '';
              this.$set(this.form, blockItem.id, value);

              blockItem.type === 'checkbox' && this.addToCheckboxFields(blockItem.id);

              /* istanbul ignore else */
              if (blockItem.id === 'phone' || blockItem.id === 'additional-phone' || blockItem.id === 'zipcode') {
                this.fieldsData[blockItem.id] = {
                  index: {
                    section: blockIndex,
                    indexInSection: blockItemIndex
                  }
                };
              }

              /* istanbul ignore else */
              if (!!blockItem.apiUrl) {
                this.fieldsData[blockItem.id] = blockItem.apiUrl;
              }
              /* istanbul ignore else */
              if (blockItem.id === 'state') {
                this.fieldsData[blockItem.id] = blockItem;
              }
              if (blockItem.id === 'mobile-prefix') {
                this.fieldsData[blockItem.id] = blockItem;
              }
            } else {
              this.form[blockItem.group.id] = {};

              blockItem.group.type === 'checkbox' && this.addToCheckboxFields(blockItem.group.id);

              blockItem.group.options.forEach((field) => {
                /* istanbul ignore next */
                typeof field.value === 'boolean' || typeof field.value === 'string' ? value = field.value : value = '';
                this.$set(this.form[blockItem.group.id], field.id, value);
              });
            }
          });
          this.mountFields = true;
        });
      },

      /* / custom fields creation */

      setCheckboxesToVueData() {
        this.fieldCheckboxes.forEach((item) => {
          this.$set(this.form.gdpr, `checkbox-${item.gdprId}`, item.value);
        });
      },
      setBirthValidation(payload) {
        this.isBirthValid = payload;
      },
      setBirthData(payload) {
        this.form.birth[payload.type] = payload.value;
      },
      setPredefinedValues() {
        Object.keys(this.$props).forEach((item) => {
          switch (item) {
            case 'fieldGender':
              this.form.gender = this.$props[item].value || '';
              break;
            case 'fieldFirstName':
              this.form.firstName = this.$props[item].value || '';
              break;
            case 'fieldLastName':
              this.form.lastName = this.$props[item].value || '';
              break;
            case 'fieldBirth':
              this.form.birth.day = this.$props[item].day.value || '';
              this.form.birth.month = this.$props[item].month.value || '';
              this.form.birth.year = this.$props[item].year.value || '';
              break;

            default:
              break;
          }
        });
      },

      getCaptchaError(val) {
        this.hasErrorCapcha = val;
      },

      /** check if captcha required for validation before sending a request
       * @param {function} callback - function to call after validation
       */
      validateCapcha(callback) {
        if (this.fieldCaptcha.isVisible) {
          this.$refs.captcha.checkCaptcha();

          this.$nextTick(() => {
            /* istanbul ignore else */
            if (!this.hasErrorCapcha) {
              callback();
            }
          });

        } else {
          callback();
        }
      },

      getCountryStates(country) {
        this.disableState = true;
        postData(`${window.location.origin}/${this.fieldsData.country}`, { country: country.trim() })
          .then((response) => {
            this.mobileprefix = response.mobileprefix;

            (!!this.regExp.phone || this.regExp.phone === '') && this.setRegexp({ field: 'phone', regexp: response.phonereg });
            (!!this.regExp['additional-phone'] || this.regExp['additional-phone'] === '')  && this.setRegexp({ field: 'additional-phone', regexp: response.additionalphonereg });
            (!!this.regExp.zipcode || this.regExp.zipcode === '') && this.setRegexp({ field: 'zipcode', regexp: response.zipcode });


            setTimeout(() => {
              /* istanbul ignore else */
              if (!!this.regExp.phone || this.regExp.phone === '') {
                this.vulidateSettings = 'phone';
              }
              /* istanbul ignore else */
              if (!!this.fieldsData.phone) {
                this.fieldsList = { id: 'phone', info: response.phonereghelptext || '' };
              }

              /* istanbul ignore else */
              if (!!this.regExp['additional-phone'] || this.regExp['additional-phone'] === '') {
                this.vulidateSettings = 'additional-phone';
              }
              /* istanbul ignore else */
              if (!!this.fieldsData['additional-phone']) {
                this.fieldsList = { id: 'additional-phone', info: response.additionalphonereghelptext || '' };
              }

              /* istanbul ignore else */
              if (!!this.regExp.zipcode || this.regExp.zipcode === '') {
                this.vulidateSettings = 'zipcode';
              }
              /* istanbul ignore else */
              if (!!this.fieldsData.zipcode) {
                this.fieldsList = { id: 'zipcode', info: response.zipcodehelptext || '' };
              }

            }, 100);

            /** trigger fields to update */
            setTimeout(() => {
              this.fieldsKey = Date.now();
              /* eslint-disable no-console */
              console.log(`update fieldKey ${this.fieldsKey}`);
            }, 300);

            this.disableState = false;
          })
          .catch((err) => {
            return err;
          });
      },

      objectMap(object, mapFn) {
        return Object.keys(object).reduce(function(result, key) {
          result[key] = mapFn(object[key], key);
          return result;
        }, {});
      },

      addToCheckboxFields(id) {
        this.checkboxFieldIDs.push(id);
      },

      sendRequest() {
        const gdpr = this.fieldCheckboxes.map((item, index) => {
          return {
            gdrpSettingItemId: this.fieldCheckboxes[index].gdprId,
            isSelected: this.form.gdpr[`checkbox-${item.gdprId}`]
          };
        });

        const serializedForm = this.objectMap(this.form, (value, key) => {
          if (typeof value === 'object' && this.checkboxFieldIDs.includes(key)) {
            const checkedValues = [];
            for (const key in value) {
              if (value.hasOwnProperty(key)) {
                value[key] && checkedValues.push(key);
              }
            }
            return checkedValues;
          } else {
            return value;
          }
        });

        postData(`${window.location.origin}/${this.apiUrl}`, {
          ...serializedForm,
          gdpr
        }).then((response) => {
          this.serverResponse = response.status;
        }).catch(() => {
          this.serverError = true;
        });

      },

      /**
       * @todo
       * @returns {undefined}
       */
      submit() {
        this.sendRequest();
        this.validateDate = false;
        this.$v.form.$touch();

        this.$nextTick(() => {
          this.validateDate = true;
          setTimeout(() => {
            if (!this.isGroupsValid || !this.isBirthValid || (this.$v.form.$pending || this.$v.form.$error)) {
              return;
            } else {
              //this.validateCapcha(this.sendRequest);
            }
          }, 200);
        });
      }
    }
  };
</script>

<style lang='scss' src="./custom-form-personal-info.scss"></style>
